var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel4Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 327,
    viewBox: "0 0 790 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 278.5,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint0_radial_7152_2954)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 278.501,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint1_radial_7152_2954)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.227 40.5256C391.279 38.1623 396.288 38.1623 400.34 40.5256L481.011 87.5841C485.009 89.9159 487.467 94.1955 487.467 98.8232V193.174C487.467 197.801 485.009 202.081 481.011 204.413L400.34 251.471C396.288 253.834 391.279 253.834 387.227 251.471L306.556 204.413C302.558 202.081 300.1 197.801 300.1 193.174V98.8233C300.1 94.1955 302.558 89.9159 306.556 87.5841L387.227 40.5256Z",
    fill: "url(#paint2_linear_7152_2954)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7152_2954)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.498 76.3579C392.528 75.1705 395.04 75.1705 397.069 76.3579L451.718 108.333C453.712 109.5 454.938 111.638 454.938 113.948V178.05C454.938 180.361 453.712 182.498 451.718 183.665L397.069 215.64C395.04 216.828 392.528 216.828 390.498 215.641L335.85 183.665C333.855 182.498 332.629 180.361 332.629 178.05V113.948C332.629 111.638 333.855 109.5 335.85 108.333L390.498 76.3579Z",
    fill: "url(#paint3_radial_7152_2954)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.498 76.3579C392.528 75.1705 395.04 75.1705 397.069 76.3579L451.718 108.333C453.712 109.5 454.938 111.638 454.938 113.948V178.05C454.938 180.361 453.712 182.498 451.718 183.665L397.069 215.64C395.04 216.828 392.528 216.828 390.498 215.641L335.85 183.665C333.855 182.498 332.629 180.361 332.629 178.05V113.948C332.629 111.638 333.855 109.5 335.85 108.333L390.498 76.3579Z",
    fill: "url(#paint4_radial_7152_2954)",
    fillOpacity: 0.29
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.498 76.3579C392.528 75.1705 395.04 75.1705 397.069 76.3579L451.718 108.333C453.712 109.5 454.938 111.638 454.938 113.948V178.05C454.938 180.361 453.712 182.498 451.718 183.665L397.069 215.64C395.04 216.828 392.528 216.828 390.498 215.641L335.85 183.665C333.855 182.498 332.629 180.361 332.629 178.05V113.948C332.629 111.638 333.855 109.5 335.85 108.333L390.498 76.3579Z",
    fill: "url(#paint5_linear_7152_2954)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M454.346 103.841L399.698 71.8657C396.045 69.7284 391.523 69.7284 387.87 71.8657L333.221 103.841C329.631 105.942 327.425 109.789 327.425 113.948V178.05C327.425 182.21 329.631 186.057 333.221 188.157L387.87 220.133C391.523 222.27 396.045 222.27 399.698 220.133L454.346 188.157C457.936 186.057 460.143 182.21 460.143 178.05V113.948C460.143 109.789 457.936 105.942 454.346 103.841Z",
    stroke: "url(#paint6_linear_7152_2954)",
    strokeWidth: 10.4093
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M457.266 98.9071L402.617 67.1115C397.156 63.9344 390.41 63.9344 384.95 67.1115L330.301 98.9071C324.895 102.052 321.569 107.835 321.569 114.09V177.907C321.569 184.162 324.895 189.945 330.301 193.09L384.95 224.886C390.41 228.063 397.156 228.063 402.617 224.886L457.266 193.09C462.672 189.945 465.998 184.162 465.998 177.908V114.09C465.998 107.835 462.672 102.052 457.266 98.9071Z",
    stroke: "url(#paint7_linear_7152_2954)",
    strokeWidth: 1.30116
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_7152_2954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.209 128.574L395.028 120.514C394.614 120.376 394.167 120.376 393.753 120.514L369.572 128.574C369.171 128.708 368.822 128.964 368.575 129.308C368.327 129.651 368.194 130.063 368.194 130.486V150.637C368.194 151.171 368.407 151.684 368.785 152.062C369.162 152.44 369.675 152.652 370.209 152.652C370.744 152.652 371.256 152.44 371.634 152.062C372.012 151.684 372.225 151.171 372.225 150.637V133.282L380.685 136.1C378.438 139.732 377.723 144.108 378.698 148.266C379.673 152.424 382.259 156.026 385.887 158.279C381.353 160.057 377.434 163.274 374.567 167.672C374.418 167.894 374.314 168.143 374.262 168.405C374.21 168.667 374.211 168.936 374.264 169.198C374.317 169.46 374.422 169.708 374.572 169.929C374.722 170.15 374.914 170.339 375.138 170.485C375.362 170.631 375.612 170.731 375.875 170.779C376.138 170.827 376.407 170.823 376.668 170.766C376.929 170.709 377.176 170.601 377.395 170.448C377.614 170.294 377.8 170.099 377.942 169.874C381.738 164.05 387.733 160.712 394.391 160.712C401.048 160.712 407.043 164.05 410.839 169.874C411.135 170.313 411.591 170.618 412.11 170.723C412.629 170.829 413.168 170.726 413.612 170.436C414.055 170.147 414.367 169.695 414.48 169.178C414.593 168.66 414.497 168.12 414.214 167.672C411.348 163.274 407.413 160.057 402.894 158.279C406.519 156.026 409.102 152.427 410.077 148.271C411.052 144.116 410.34 139.744 408.096 136.113L419.209 132.41C419.611 132.277 419.96 132.02 420.207 131.677C420.454 131.334 420.587 130.921 420.587 130.498C420.587 130.075 420.454 129.663 420.207 129.32C419.96 128.977 419.611 128.72 419.209 128.587V128.574ZM406.481 144.592C406.482 146.503 406.029 148.387 405.16 150.09C404.292 151.793 403.032 153.265 401.484 154.386C399.936 155.508 398.144 156.246 396.255 156.541C394.367 156.836 392.435 156.679 390.619 156.082C388.803 155.486 387.154 154.468 385.808 153.111C384.462 151.754 383.456 150.097 382.874 148.276C382.292 146.456 382.15 144.523 382.46 142.637C382.769 140.75 383.522 138.964 384.655 137.425L393.753 140.448C394.167 140.586 394.614 140.586 395.028 140.448L404.126 137.425C405.657 139.501 406.483 142.012 406.481 144.592Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7152_2954",
    x: 322.22,
    y: 65.0586,
    width: 143.127,
    height: 161.881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.276
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.203922 0 0 0 0 0.176471 0 0 0 0 0.478431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7152_2954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_7152_2954",
    x: 362.149,
    y: 114.365,
    width: 64.4834,
    height: 68.1324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.25833
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7152_2954"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7152_2954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 278.5) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C393F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7152_2954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 278.501) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C393F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7152_2954",
    x1: 335.882,
    y1: 51.6645,
    x2: 420.457,
    y2: 244.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8058CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7152_2954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(393.784 149.166) rotate(90) scale(116.407 100.652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312974"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_7152_2954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(365.204 121.86) rotate(-48.4041) scale(72.063 37.9922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7152_2954",
    x1: 393.784,
    y1: 74.4355,
    x2: 393.784,
    y2: 223.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#765913",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#30297A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30297A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7152_2954",
    x1: 393.784,
    y1: 74.4355,
    x2: 393.784,
    y2: 223.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#966FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C696F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7152_2954",
    x1: 379.471,
    y1: 62.7246,
    x2: 408.096,
    y2: 232.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5B3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A075E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel4Badge);
export default __webpack_public_path__ + "static/media/Level4Badge.889283f9185b58e7156d32f5ffea94e7.svg";
export { ForwardRef as ReactComponent };